// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
import Body from 'components/text/Body';
import DisplayLabel from 'components/text/DisplayLabel';
import phone from 'phone';

const Container = styled.div`
  margin-top: 5px;
`;

const LabelValueItem = ({ value, label }) => {
  if (!value) {
    return null;
  }
  return (
    <Container>
      <DisplayLabel>{label}</DisplayLabel>
      <Body>{value}</Body>
    </Container>
  );
};

class ClientHeaderRight extends React.Component {
  render() {
    const { client } = this.props;
    return (
      <div>
        <LabelValueItem value={client.cellPhone} label="CELL PHONE" />
        {client.phone && (
          <LabelValueItem
            value={<a href={`tel:${phone(client.phone)[0]}`}>{phone(client.phone)[0]}</a>}
            label="PHONE"
          />
        )}
        <LabelValueItem value={client.street1} label="street1" />
        <LabelValueItem value={client.street2} label="street2" />
        <LabelValueItem value={client.state} label="state" />
        <LabelValueItem value={client.zip} label="zip" />
        <LabelValueItem value={client.whereDidYouHearAboutUs} label="Where did you hear about us?" />
      </div>
    );
  }
}

export default ClientHeaderRight;



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientHeader/ClientHeaderRight/index.js